"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapturePaypalPaymentOrder = exports.CreatePaypalPaymentOrder = exports.CapturePaypalOrder = exports.CreatePaypalOrder = exports.validatePaymentForm = exports.validateOrderForm = exports.printOrder = exports.sendOrder = exports.voidOrder = exports.getReports = exports.submitPayment = exports.searchOrders = exports.deleteOrder = exports.createOrder = exports.updateOrder = exports.getOrders = exports.showOrder = void 0;
exports.getSalesReports = getSalesReports;
exports.getStudentPaymentMethods = getStudentPaymentMethods;
var HttpClient_1 = require("../core/HttpClient");
var queryString_1 = require("../../../app/common/helpers/queryString");
var showOrder = function (id) {
    return HttpClient_1.HttpClient.get("/crm/orders/".concat(id));
};
exports.showOrder = showOrder;
var getOrders = function (data) {
    if (data === void 0) { data = null; }
    if (data !== null) {
        return HttpClient_1.HttpClient.get("/crm/orders?".concat((0, queryString_1.toQueryString)(data)));
    }
    return HttpClient_1.HttpClient.get("/crm/orders");
};
exports.getOrders = getOrders;
var updateOrder = function (request) {
    return HttpClient_1.HttpClient.put("/crm/orders/".concat(request.id), request);
};
exports.updateOrder = updateOrder;
var createOrder = function (request) {
    return HttpClient_1.HttpClient.post("/crm/orders", request);
};
exports.createOrder = createOrder;
var deleteOrder = function (data) {
    return HttpClient_1.HttpClient.delete("/crm/orders/".concat(data.id));
};
exports.deleteOrder = deleteOrder;
var searchOrders = function (params) {
    return HttpClient_1.HttpClient.post("/crm/orders/search", params);
};
exports.searchOrders = searchOrders;
var submitPayment = function (data) {
    return HttpClient_1.HttpClient.post("/crm/orders/".concat(data.order_id, "/payments"), data);
};
exports.submitPayment = submitPayment;
var getReports = function (data) {
    return HttpClient_1.HttpClient.get("/crm/orders/reports?".concat((0, queryString_1.toQueryString)(data)));
};
exports.getReports = getReports;
var voidOrder = function (order_id) {
    return HttpClient_1.HttpClient.post("/crm/orders/".concat(order_id, "/void"), {});
};
exports.voidOrder = voidOrder;
var sendOrder = function (order_id, data) {
    return HttpClient_1.HttpClient.post("/crm/orders/".concat(order_id, "/send"), data);
};
exports.sendOrder = sendOrder;
var printOrder = function (order_id) {
    return HttpClient_1.HttpClient.post("/crm/orders/".concat(order_id, "/print"), {});
};
exports.printOrder = printOrder;
var validateOrderForm = function (data) {
    return HttpClient_1.HttpClient.post("/crm/order-form/validate", data);
};
exports.validateOrderForm = validateOrderForm;
var validatePaymentForm = function (data) {
    if (typeof data.order_id === "undefined") {
        throw Error("You must have an order ID in order to validate this form.");
    }
    var order_id = data.order_id;
    delete data.order_id;
    return HttpClient_1.HttpClient.post("/crm/orders/".concat(order_id, "/payments/validate"), data);
};
exports.validatePaymentForm = validatePaymentForm;
/**
 * Create an order if using PayPal
 */
var CreatePaypalOrder = function (data) {
    return HttpClient_1.HttpClient.post("/crm/paypal/order", data);
};
exports.CreatePaypalOrder = CreatePaypalOrder;
/**
 * Confirm/approve a PayPal order after PayPal has captured the payment.
 * This triggers internal processing (notifications, accreditation, etc.)
 *
 * @param order_id - The DriveScout order ID (not the PayPal order ID)
 * @param paypal_order_id - The PayPal order ID from the onApprove callback
 * @param payment_token - Optional payment token from PayPal
 */
var CapturePaypalOrder = function (data) {
    return HttpClient_1.HttpClient.post("/crm/paypal/order/".concat(data.order_id, "/approve"), {
        paypal_order_id: data.paypal_order_id,
        payment_token: data.payment_token,
    });
};
exports.CapturePaypalOrder = CapturePaypalOrder;
function getSalesReports(params) {
    if (params !== null) {
        return HttpClient_1.HttpClient.get("/crm/orders/sales-reports?".concat((0, queryString_1.toQueryString)(params)));
    }
    return HttpClient_1.HttpClient.get("/crm/orders/sales-reports");
}
function getStudentPaymentMethods(id) {
    return HttpClient_1.HttpClient.get("/users/students/".concat(id, "/payment-methods"));
}
var CreatePaypalPaymentOrder = function (data) {
    return HttpClient_1.HttpClient.post("/crm/orders/".concat(data.order_id, "/paypal/order"), {
        payment_amount: data.payment_amount,
        request_id: data.request_id,
    });
};
exports.CreatePaypalPaymentOrder = CreatePaypalPaymentOrder;
var CapturePaypalPaymentOrder = function (data) {
    return HttpClient_1.HttpClient.post("/crm/orders/".concat(data.order_id, "/paypal/order/").concat(data.paypal_order_id, "/capture"), {});
};
exports.CapturePaypalPaymentOrder = CapturePaypalPaymentOrder;
